export default __webpack_public_path__ + "images/open-book.77952108.png";